/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_EnglishInputs */

const en_common_english = /** @type {(inputs: Common_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const es_common_english = /** @type {(inputs: Common_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Common_EnglishInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_english = /** @type {((inputs?: Common_EnglishInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_EnglishInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_english(inputs)
	return en_common_english(inputs)
});